import React from 'react';
import PropTypes from 'prop-types';
import urlJoin from 'url-join';
import QuickLinks from './quick-links';

function MissingPersonsQuickLinks(props) {
    const { name, url } = props;

    const links = [
        {
            id: 'missing-persons',
            text: 'Missing Persons',
            url: urlJoin(url, '/'),
        },
    ];

    return <QuickLinks title={name} links={links} />;
}

MissingPersonsQuickLinks.propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default MissingPersonsQuickLinks;
